<template>
    <li class="menu">
        <a class="dropdown-toggle" data-bs-toggle="collapse" data-bs-target="#referral_program" aria-controls="referral_program" aria-expanded="false">
            <div class="">
                <svg width="800px" height="800px" viewBox="0 0 512 512" id="Layer_1" version="1.1" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                    <g>
                        <g>
                            <g>
                                <g>
                                    <path
                                        class="st0"
                                        fill="#FEDD8E"
                                        d="M377.6,385.3c-4,6.6-10.9,10-17.9,10c-3.9,0-7.6-1-11-3.1l2.5,1.6c10,6.2,13,19.3,6.9,29.1      c-4,6.5-10.9,10-17.9,10c-2.9,0-5.7-0.6-8.4-1.8l0.4,0.4c9.9,6.1,13.1,19.2,6.9,29.1c-4,6.6-10.9,10-18,10      c-3.6,0-7.3-0.9-10.6-2.9c8.1,6.6,10.2,18.2,4.5,27.5c-6.3,10.1-19.4,12.8-29,6.9l-97.9-60.2l-55.4-25.2l-18.8-48.4l-101-57.4      V153.4l160.5,87.1l48.8-30.5l41,10.9l-16.4,61.5l124,73.9C380.6,362.3,383.7,375.5,377.6,385.3z"
                                    />
                                </g>

                                <g>
                                    <path
                                        class="st1"
                                        fill="#FEE9B4"
                                        d="M377.6,385.3c-3.3,5.4-8.6,8.7-14.2,9.7c1.5-8.2-2.1-17-9.7-21.7l-124-73.9l16.4-61.5l-27.3-2.4L170,266      L12.9,179.7v-26.3l160.5,87.1l48.8-30.5l41,10.9l-16.4,61.5l124,73.9C380.6,362.3,383.7,375.5,377.6,385.3z"
                                    />
                                </g>

                                <g>
                                    <path
                                        class="st2"
                                        fill="#FDD367"
                                        d="M317.7,487.7c-0.4,2.5-1.4,5.1-2.8,7.4c-6.3,10.1-19.4,12.8-29,6.9L188,441.8l-55.4-25.2l-18.8-48.4      l-101-57.4v-26.7L131,351.2l18.8,48.4l55.4,25.2L303,485c3.4,2.1,7.2,3.1,11.1,3.1C315.3,488.1,316.5,488,317.7,487.7z"
                                    />
                                </g>

                                <g>
                                    <path
                                        class="st1"
                                        fill="#FEE9B4"
                                        d="M499.1,112.9v158.8l-79.1,38l-49.3,46.6l-124-73.9l-8.1,24.5c-6,18.2-22.2,31-41.5,32.5l-21.2,0.5      l31.9-81.6l55.2-37.5h48.9L499.1,112.9z"
                                    />
                                </g>

                                <g>
                                    <path class="st3" fill="#FFF3D9" d="M499.1,113v27l-173,99.8h-49l-55.2,37.4l-24.3,62c-0.1,0.1,1,0.1-21.7,0.7l31.9-81.6l55.2-37.4h49      L499.1,113z" />
                                </g>

                                <g>
                                    <polygon class="st0" fill="#FEDD8E" points="499.1,246.5 499.1,271.7 420,309.6 370.8,356.2 349.9,343.8 406,290.7     " />
                                </g>

                                <path
                                    class="st1"
                                    fill="#FEE9B4"
                                    d="M158.9,441c-1.8,3.1-5.8,4.1-8.9,2.3l-24.5-14.4c-3.1-1.8-4.1-5.8-2.3-8.9l14.4-24.5     c1.8-3.1,5.8-4.1,8.9-2.3l24.5,14.4c3.1,1.8,4.1,5.8,2.3,8.9"
                                />

                                <path
                                    class="st1"
                                    fill="#FEE9B4"
                                    d="M208.5,437.8l-14.4,24.5c-1.8,3.1-5.8,4.1-8.9,2.3l-24.5-14.4c-3.1-1.8-4.1-5.8-2.3-8.9l14.4-24.5     c1.8-3.1,5.8-4.1,8.9-2.3l24.5,14.4C209.3,430.7,210.3,434.7,208.5,437.8z"
                                />

                                <path
                                    class="st1"
                                    fill="#FEE9B4"
                                    d="M243.7,459.1l-14.4,24.5c-1.8,3.1-5.8,4.1-8.9,2.3L196,471.5c-3.1-1.8-4.1-5.8-2.3-8.9l14.4-24.5     c1.8-3.1,5.8-4.1,8.9-2.3l24.5,14.4C244.5,452,245.5,456,243.7,459.1z"
                                />

                                <path
                                    class="st1"
                                    fill="#FEE9B4"
                                    d="M279,480.4l-14.4,24.5c-1.8,3.1-5.8,4.1-8.9,2.3l-24.5-14.4c-3.1-1.8-4.1-5.8-2.3-8.9l14.4-24.5     c1.8-3.1,5.8-4.1,8.9-2.3l24.5,14.4C279.7,473.3,280.8,477.3,279,480.4z"
                                />

                                <path
                                    class="st4"
                                    fill="#333333"
                                    d="M501.1,109.6c-1.2-0.7-2.7-0.7-3.9,0L311,217h-47.4c-41.8-10.7-41.1-12-43.7-10.3L173.2,236L14.7,150     c-2.3-1.4-5.8,0.3-5.8,3.5v158.1c0,2.1,1.7,3.9,3.9,3.9l97.9,55.7l14.6,37.7l-5.5,9.4c-2.8,4.8-1.4,11.2,3.7,14.2l24.5,14.4     c3,1.8,6.1,1.3,6.2,1.3c0.8,2.3,2.3,4.3,4.5,5.6l24.5,14.4c3.3,1.9,6.1,1.3,6.2,1.3c0.8,2.3,2.3,4.3,4.5,5.6l24.5,14.4     c3,1.8,6.1,1.3,6.2,1.3c0.8,2.3,2.3,4.3,4.5,5.6l24.5,14.4c5,2.8,11.2,1.3,14.1-3.7l4.9-8.3l11.1,6.8c11.6,7,26.9,3.6,34.3-8.2     c4.4-7.2,4.9-15.6,1.9-22.8c9.2,0.5,17.5-4.2,22.2-11.8c4.6-7.4,5.3-17.2,0.3-25.9c7.7-0.8,14.6-5,18.7-11.7     c5.1-8.3,4.9-18,0.4-25.9c7.9-0.6,15-4.9,19.2-11.8c6.4-10.3,4.3-23.6-4.2-31.4l45.5-43l78.6-37.7c1.4-0.6,2.3-2,2.3-3.6V112.9     C503,111.5,502.3,110.3,501.1,109.6z M154.9,439.7c-1.3,0.8-2.3,0.7-2.9,0.2l-24.5-14.4c-1.1-0.5-1.8-2.4-0.9-3.5l14.4-24.5     c0.5-1.1,2.4-1.8,3.5-0.9L169,411c1.1,0.6,1.5,1.9,1.1,3C168.7,416.1,155.2,439.4,154.9,439.7z M190.2,461     c-1.3,0.8-2.3,0.7-2.9,0.2l-24.5-14.4c-1.2-0.7-1.6-2.3-0.9-3.5l14.4-24.5c0.6-1.1,2.5-1.8,3.6-0.9l24.5,14.4     c1.1,0.6,1.5,1.9,1.1,3C205.1,435.9,190.2,460.7,190.2,461z M225.3,482.3c-1.3,0.8-2.3,0.7-2.9,0.2L198,468.2     c-1.2-0.7-1.6-2.3-0.9-3.5l14.4-24.5c0.6-1.1,2.5-1.8,3.6-0.9l24.5,14.4c1.1,0.5,1.6,2.1,1.1,3     C239.6,458.4,225.5,482.1,225.3,482.3z M275.6,478.4l-14.4,24.5c-0.5,1.1-2.4,1.8-3.5,0.9l-24.5-14.4c-1.1-0.5-1.8-2.4-0.9-3.5     l14.4-24.5c0.9-1.4,2.6-1.6,3.5-0.9l24.5,14.4C275.8,475.4,276.3,476.9,275.6,478.4z M374.2,383.3c-3.1,5.1-8.5,8.1-14.6,8.1     c-3.2,0-6.2-0.9-9-2.6h-0.1l-39.9-23.9c-1.8-1.1-4.2-0.5-5.4,1.3c-1.1,1.9-0.5,4.3,1.3,5.4c0.2,0.1-3.3-2,42.5,25.6     c8,4.9,10.7,15.3,5.6,23.8c-3.1,5.1-8.6,8.1-14.6,8.1c-2.4,0-4.5-0.5-6.7-1.4l-47-28.7c-1.8-1.1-4.2-0.5-5.4,1.3     c-1.1,1.8-0.5,4.2,1.3,5.4c0.1,0.1,47.6,29.2,47.7,29.2c7.9,4.9,10.9,15.3,5.7,23.7c-3.1,5.1-8.6,8.1-14.7,8.1     c-3,0-6-0.8-8.5-2.3l-42.7-27.1c-1.8-1.2-4.2-0.6-5.4,1.2c-1.2,1.8-0.6,4.2,1.2,5.4l42.4,27c6.6,5.5,8.1,14.8,3.6,22.3     c-5.3,8.5-16.2,10.2-23.6,5.6l-11.2-6.9l5.6-9.5c2.9-4.9,1.2-11.3-3.7-14.2l-24.5-14.4c-2-1.1-4.1-1.6-6.2-1.4     c-0.8-2.3-2.4-4.3-4.5-5.6l-24.5-14.4c-1.9-1.1-4.1-1.6-6.3-1.3c-0.8-2.3-2.2-4.3-4.4-5.6l-24.5-14.4c-1.9-1.1-4.1-1.6-6.2-1.4     c-0.8-2.3-2.3-4.3-4.5-5.6l-24.5-14.4c-4.8-2.8-11.2-1.4-14.2,3.7l-3.8,6.5l-12.9-33.2c-0.3-0.8-0.9-1.5-1.7-2l-99.1-56.3V159.9     c162.8,87.5,154.8,86.1,158.6,83.9l47.3-29.6l31.1,8.3l-48.1,32.6c-0.7,0.4-1.2,1.1-1.4,1.8l-31.9,81.6c-0.9,2.1,0.2,5.1,3.7,5.4     l21.4-0.5c20.8-1.6,38.4-15.4,44.9-35.2l6.5-19.8l119.7,71.3C376.6,364.6,379.3,375.3,374.2,383.3z M495.2,269.2l-76.9,36.9     c-0.4,0.2-0.8,0.4-1.1,0.7l-47.1,44.5l-116-69.1l30.2-19.4c1.8-1.2,2.3-3.6,1.2-5.4c-1.2-1.8-3.6-2.3-5.4-1.2     c-40,25.5-36.2,23-37.2,24.9l-8.1,24.5c-5.5,16.8-20.4,28.5-37.9,29.8l-15.3,0.4l29.3-74.9l53.2-36.1c49.6-0.2,47.8,0.5,49.7-0.5     L495,119.8v149.4H495.2z"
                                />
                            </g>

                            <g>
                                <g>
                                    <path class="st5" fill="#7BDE9E" d="M315.7,158.5c-36.3,33-92.4,30.3-125.4-6S159.9,60,196.2,27.1c36.3-33,92.5-30.3,125.5,6      S352,125.5,315.7,158.5z" />
                                </g>

                                <g>
                                    <path
                                        class="st6"
                                        fill="#51D27F"
                                        d="M315.8,158.5c-36.3,33-92.5,30.3-125.5-5.9c-3.4-3.7-6.3-7.5-8.9-11.6c33.6,27.8,83.2,27.5,116.4-2.7      c32.6-29.7,38.1-78.1,14.8-113.9c3.2,2.6,6.3,5.5,9.2,8.7C354.7,69.4,352.1,125.6,315.8,158.5z"
                                    />
                                </g>

                                <g>
                                    <path
                                        class="st7"
                                        fill="#A7EABF"
                                        d="M330.6,44.6c-33.6-27.8-83.2-27.5-116.3,2.7c-32.6,29.6-38.1,78-14.9,113.9c-3.2-2.7-6.2-5.6-9.1-8.7      c-33-36.3-30.4-92.5,5.9-125.4c36.3-33,92.5-30.4,125.5,6C325,36.8,328,40.6,330.6,44.6z"
                                    />
                                </g>

                                <g>
                                    <g>
                                        <path
                                            class="st4"
                                            fill="#333333"
                                            d="M187.3,155.3c-34.1-37.6-32.2-96.3,6.2-131.2c37.9-34.4,96.7-31.6,131.2,6.3       c34.3,37.5,31.9,96.5-6.3,131.2l0,0C280.1,196.3,221.4,192.7,187.3,155.3z M198.9,30.1c-34.6,31.5-37.2,85.1-5.6,119.8       c31.4,34.6,85.2,37.2,119.7,5.7l0,0c34.4-31.2,37.6-84.9,5.7-119.7C287.5,1.4,233.7-1.5,198.9,30.1z"
                                        />
                                    </g>
                                </g>
                            </g>
                        </g>

                        <g>
                            <path
                                class="st8"
                                fill="#FC8A8A"
                                d="M237.7,133.4L237.7,133.4c-3.2,0-6.2-1.3-8.5-3.5l-20.7-20.7c-4.7-4.7-4.7-12.3,0-16.9    c4.7-4.7,12.3-4.7,16.9,0l12.2,12.2l48.8-48.8c4.7-4.7,12.2-4.7,16.9,0s4.7,12.2,0,16.9l-57.2,57.2    C243.9,132.1,240.9,133.4,237.7,133.4z"
                            />
                        </g>

                        <g>
                            <path
                                class="st9"
                                fill="#F96364"
                                d="M303.4,72.6l-10.2,10.2c4.7-4.6,4.7-12.2,0-16.9c-4.7-4.6-12.2-4.6-16.9,0l10.2-10.2c4.7-4.7,12.3-4.7,16.9,0    C308.1,60.4,308.1,67.9,303.4,72.6z"
                            />
                        </g>

                        <g>
                            <path
                                class="st10"
                                fill="#FCB0B0"
                                d="M253.8,122.2l-7.6,7.6c-4.5,4.5-11.9,4.8-16.9,0l-20.7-20.7c-4.7-4.6-4.7-12.2,0-16.9c1.4-1.4,3-2.4,4.8-2.9    c-1.4,4.2-0.4,8.9,2.9,12.2l20.7,20.7c2.2,2.2,5.3,3.5,8.5,3.5C248.5,125.7,251.6,124.5,253.8,122.2z"
                            />
                        </g>

                        <g>
                            <g>
                                <path
                                    class="st4"
                                    fill="#333333"
                                    d="M226.4,132.7L205.7,112c-6.3-6.3-6.3-16.3,0-22.6c6-6,16.6-6,22.6,0l9.4,9.4l45.9-45.9     c6.3-6.3,16.3-6.3,22.6,0c6.3,6.3,6.3,16.3,0,22.6L249,132.7C242.6,139.1,232.5,138.8,226.4,132.7z M211.4,95     c-3.1,3.1-3.1,8.1,0,11.2l20.7,20.7c3,3,8.3,3,11.3,0l57.2-57.2c3.1-3.1,3.1-8.1,0-11.2c-3-3-8.3-3-11.3,0l-48.8,48.8     c-0.8,0.8-1.8,1.2-2.8,1.2l0,0c-1.1,0-2.1-0.4-2.8-1.2l-12.2-12.2C219.1,91.7,214.3,92.1,211.4,95z"
                                />
                            </g>
                        </g>
                    </g>
                </svg>
                <span>Partnership</span>
            </div>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="feather feather-chevron-right"
            >
                <polyline points="9 18 15 12 9 6"></polyline>
            </svg>
        </a>
        <ul id="referral_program" class="collapse submenu list-unstyled">
            <li><router-link to="/referral-program/invite">Invite & Earn</router-link></li>
            <!-- <li><router-link to="/referral-program/statistics">Reports</router-link></li> -->
        </ul>
    </li>
</template>
